










	import {Vue, Component} from 'vue-property-decorator';
	import ModalWindow from "@/components/Common/ModalWindow.vue";

	@Component({
		components: {
		    ModalWindow,
		}
	})
    export default class ContactsGallery extends Vue{
	    private imageBaseUrl: string = "https://kursufa.ru/js/static/certs/";

	    private activeImage: string = "";
	    private dialogVisible: boolean = false;

	    private images: Image[] = [
	        new Image("1s", "1"),
            new Image("2s", "2"),
            new Image("3s", "3"),
		]

		private getUrl(image: Image, full?: boolean){
	        if(full){
	            return `${this.imageBaseUrl}${image.Full}.png`
			}
            return `${this.imageBaseUrl}${image.Small}.png`
		}

        previewImage(image: Image){
	        this.activeImage = this.getUrl(image, true);
	        this.dialogVisible = true;
		}
	}

	export class Image{
	    constructor(small: string, full: string) {
        	this.Full = full;
        	this.Small = small;
	    }

        Small: string;
	    Full: string;
	}
